import React from 'react';

/* === COMMENTED OUT - ORIGINAL SITE CODE ===
import React, {Fragment} from 'react';
import Switcher from "./components/Switcher";
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

import ErrorPage from "./pages/404Error";
import HomePage from "./pages/home/HomePage";
import BlogDetailsPage from "./pages/blog/BlogDetails";
import BlogThreeColumnPage from "./pages/blog/ThreeColumn";
import PortfolioGridThreeColumnFullWidth from "./pages/portfolio/grid/three-column-fullwidth";
import PortfolioGridThreeColumnPage from "./pages/portfolio/grid/three-column";
import BlogDetailsLeftSidebarPage from "./pages/blog/BlogDetailsLeftSidebar";
const App = () => {
    return (
        <Fragment>
            <Switcher/>
            <Router>
                <Switch>
                    <Route path="/blog-posts"
                           component={BlogThreeColumnPage}/>
                    <Route exact path="/"
                           component={HomePage}
                    />
                    <Route path="/builds"
                           component={BlogThreeColumnPage}/>
                    <Route exact component={ErrorPage}/>
                </Switch>
            </Router>
        </Fragment>
    );
};
=== END COMMENTED OUT CODE === */

const App = () => {
    return (
        <div className="building-page">
            <h1 className="building-text">
                Building{' '}
                <a href="https://cfosilvia.com" className="silvia-link">
                    Silvia
                </a>
                <span className="dots">
                    <span className="dot">.</span>
                    <span className="dot">.</span>
                    <span className="dot">.</span>
                </span>
            </h1>
        </div>
    );
};

export default App;